/**
 * Listens for the Konami code and fires a callback when the full sequence is
 * entered. Used to toggle the universe into its more psychedelic mode.
 */
export class KonamiListener {
  private static readonly sequence: readonly string[] = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'b',
    'a',
  ]

  private readonly onUnlock: () => void
  private progress: number

  /**
   * @param {() => void} onUnlock - Invoked when the full sequence is entered.
   */
  public constructor(onUnlock: () => void) {
    this.onUnlock = onUnlock
    this.progress = 0
    this.handleKeyDown = this.handleKeyDown.bind(this)
    window.addEventListener('keydown', this.handleKeyDown)
  }

  /**
   * Stop listening for the sequence.
   *
   * @returns {void}
   */
  public dispose(): void {
    window.removeEventListener('keydown', this.handleKeyDown)
  }

  /**
   * Advance through the sequence, resetting on any wrong key.
   *
   * @param {KeyboardEvent} event - The keydown event.
   * @returns {void}
   */
  private handleKeyDown(event: KeyboardEvent): void {
    const expected = KonamiListener.sequence[this.progress]
    if (event.key.toLowerCase() === expected.toLowerCase()) {
      this.progress += 1
      if (this.progress === KonamiListener.sequence.length) {
        this.progress = 0
        this.onUnlock()
      }
      return
    }
    this.progress = event.key === KonamiListener.sequence[0] ? 1 : 0
  }
}
